export default __webpack_public_path__ + "files/a4fadb2ea03436fed81305eaf9565713.svg";